import { COLORS } from '../colors'
import { TColorsForElementStates } from '../typings'
import { createHoverColor } from './colorManipulationUtils'

type TOptions = {
  color: string | Partial<TColorsForElementStates>
  defaultDisabledColor: string
  hoverRatio?: number
}

/**
 * takes string color or partial element-state-colors object (TColorsForElementStates)
 * and extends it into a fully defined TColorsForElementStates, filling missing properties
 */
export const ensureElementStateColors = ({
  color,
  hoverRatio,
  defaultDisabledColor,
}: TOptions): TColorsForElementStates => {
  // for string value, use the value as color for normal state,
  // use default disabled color and create default hover color based on the value
  if (typeof color === 'string') {
    return {
      normal: color,
      disabled: defaultDisabledColor,
      hover: createHoverColor(color, hoverRatio),
    }
  }

  // for (partial) object, use whatever was provided
  // and supply the rest with defaults
  const normal = color.normal ?? COLORS.speedlo
  const disabled = color.disabled ?? defaultDisabledColor
  const hover = color.hover ?? createHoverColor(normal, hoverRatio)

  return { hover, normal, disabled }
}
